import { KudosApiClient } from '@fourthwall/services/dist/KudosApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUploadKudoMutation = createMutationHook(KudosApiClient.uploadKudo, {
  mutationKey: ['uploadKudo'],
})
